<template>
  <div v-if="Object.keys(tour_data).length > 0">
    <b-modal
      id="tour-info-modal"
      ref="tour-info-modal-ref"
      hide-footer
      title="Tour Information"
    >
      <div>
        <div class="modal-banner-container" v-if="tour_data.image_banner">
          <img :src="tour_data.image_banner" class="vtd-center-image" />
          <div class="modal-banner-text">{{ tour_data.name }}</div>
        </div>
        <h4 class="mt-3 orange">Introduction</h4>
        <p class="text-left" v-html="tour_data.description"></p>
        <div class="row">
          <div class="col-md-4 vtd-font-weight-bold">Start City:</div>
          <div class="col-md-8">
            {{ tour_data.start_city }}
          </div>
        </div>
        <div class="row" v-if="tour_data.finish_city">
          <div class="col-md-4 vtd-font-weight-bold">End City:</div>
          <div class="col-md-8">
            {{ tour_data.finish_city }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 vtd-font-weight-bold">Trip Duration:</div>
          <div class="col-md-8">{{ returnDays }} days</div>
        </div>
        <div class="row" v-if="tour_data.visited_countries">
          <div class="col-md-4 vtd-font-weight-bold">Visited Countries:</div>
          <div class="col-md-8">
            {{ tour_data.visited_countries }}
          </div>
        </div>
        <div class="row" v-if="tour_data.travel_style">
          <div
            class="col-md-4 vtd-font-weight-bold"
            v-if="tour_data.travel_style"
          >
            Travel Style:
          </div>
          <div class="col-md-8">
            {{ tour_data.travel_style }}
          </div>
        </div>
        <div class="row" v-if="tour_data.trip_type">
          <div class="col-md-4 vtd-font-weight-bold" v-if="tour_data.trip_type">
            Trip Type:
          </div>
          <div class="col-md-8">
            {{ tour_data.trip_type }}
          </div>
        </div>
        <div class="row" v-if="tour_data.physical_grading">
          <div class="col-md-4 vtd-font-weight-bold">Physical Grading:</div>
          <div class="col-md-8">
            {{ tour_data.physical_grading }}
          </div>
        </div>
        <div class="row" v-if="tour_data.service_level">
          <div class="col-md-4 vtd-font-weight-bold">Service Level:</div>
          <div class="col-md-8">
            {{ tour_data.service_level }}
          </div>
        </div>
        <div class="row" v-if="tour_data.group_size_notes">
          <div class="col-md-4 vtd-font-weight-bold">Group Size:</div>
          <div class="col-md-8">
            {{ tour_data.group_size_notes }}
          </div>
        </div>
        <div class="row" v-if="tour_data.meals_included">
          <div class="col-md-4 vtd-font-weight-bold">Meals Included:</div>
          <div class="col-md-8">
            {{ tour_data.meals_included }}
          </div>
        </div>
        <div class="row" v-if="tour_data.transport">
          <div class="col-md-4 vtd-font-weight-bold">Transport:</div>
          <div class="col-md-8">
            {{ tour_data.transport }}
          </div>
        </div>
        <div class="row" v-if="tour_data.accommodation">
          <div class="col-md-4 vtd-font-weight-bold">Accomodation:</div>
          <div class="col-md-8">
            {{ tour_data.accommodation }}
          </div>
        </div>
        <div class="row" v-if="tour_data.minimum_age">
          <div class="col-md-4 vtd-font-weight-bold">Minimum Age:</div>
          <div class="col-md-8">
            {{ tour_data.minimum_age }}
          </div>
        </div>
        <div>
          <h4 class="mt-3 orange">Tour Map</h4>
          <img :src="tour_data.image_map" class="vtd-center-image" />
        </div>
        <div v-if="tour_data.itinerary_notes">
          <h4 class="mt-3 orange">Itinerary Notes</h4>
          <p v-html="tour_data.itinerary_notes"></p>
        </div>

        <h4 class="mt-3 orange">Itinerary</h4>
        <div
          v-for="value in tour_data.itinerary"
          v-bind:key="value.message"
          class="itinerary-container"
        >
          <h6 class="orange">Day {{ value.day }} {{ value.location_label }}</h6>
          <p>{{ value.summary }}</p>
          <p>{{ value.description }}</p>
          <div
            v-for="comp_value in value.components"
            v-bind:key="comp_value.index"
          >
            <div
              v-if="comp_value.type === 'ACTIVITY'"
              class="inclusion-container"
            >
              <h6 class="vtd-font-weight-bold">Included Activities</h6>
              <p>
                {{ comp_value.activity_title }}
              </p>
              <p>{{ comp_value.summary }}</p>
            </div>

            <div
              v-if="comp_value.type === 'ACCOMMODATION'"
              class="inclusion-container"
            >
              <h6 class="vtd-font-weight-bold">Example Accomodation</h6>
              <p>
                <span v-if="comp_value.accomodation_title">
                  {{ comp_value.accomodation_title
                  }}<span v-if="comp_value.accommodation_type">, </span></span
                ><span v-if="comp_value.accommodation_type">
                  {{ comp_value.accommodation_type }}</span
                >
              </p>
            </div>
            <div
              v-if="comp_value.type === 'TRANSPORT'"
              class="inclusion-container"
            >
              <h6 class="vtd-font-weight-bold">
                {{ comp_value.transport_title }}
              </h6>
              <h6
                v-if="comp_value.transport_title === ' '"
                class="vtd-font-weight-bold"
              >
                Transfer
              </h6>
              <p class="p-0 m-0">
                <small>Start: {{ comp_value.start }}</small>
              </p>
              <p class="p-0 m-0">
                <small>End: {{ comp_value.end }}</small>
              </p>
              <p>
                <small v-if="comp_value.duration_label">
                  Duration: {{ comp_value.duration_label
                  }}<span v-if="comp_value.distance_km">, </span>
                </small>
                <small v-if="comp_value.distance_km">
                  Distance: {{ comp_value.distance_km }} kms
                </small>
              </p>
              <p>{{ comp_value.summary }}</p>
              <p>{{ comp_value.instructions }}</p>
            </div>
          </div>
          <div v-if="value.optional_activities.length >= 1">
            <h6 class="vtd-font-weight-bold">Optional Activities</h6>
            <ul>
              <li
                v-for="(value, index) in value.optional_activities"
                :key="index"
              >
                {{ value.name }}
              </li>
            </ul>
          </div>
        </div>
        <template>
          <div>
            <h4 class="mt-3 orange">Gallery</h4>
            <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="4000"
              controls
              indicators
              background="#ababab"
              img-width="1024"
              img-height="480"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <div v-for="(image, index) in tour_data.images" :key="index">
                <b-carousel-slide :img-src="image"></b-carousel-slide>
              </div>
            </b-carousel>
          </div>
        </template>
        <div v-if="tour_data.travel_insurance">
          <h4 class="mt-3 orange">Trip Notes</h4>
          <h5 class="mt-3 vtd-font-weight-bold">Travel Insurance</h5>
          <p class="pre vtd-mt-3">
            {{
              tour_data.travel_insurance.replace(/(?:^Travel\sInsurance:)/, "")
            }}
          </p>
        </div>
        <h5 class="vtd-font-weight-bold mt-2" v-if="tour_data.whats_included">
          What's Included
        </h5>
        <p class="pre" v-html="tour_data.whats_included"></p>

        <h5 class="vtd-font-weight-bold" v-if="tour_data.highlights">
          Highlights
        </h5>
        <p class="pre" v-html="tour_data.highlights"></p>

        <h5 class="vtd-font-weight-bold" v-if="tour_data.important_notes">
          Important Notes
        </h5>
        <p class="pre" v-html="tour_data.important_notes"></p>

        <h5
          class="vtd-font-weight-bold"
          v-if="tour_data.group_leader_description"
        >
          Group Leader Description
        </h5>
        <p class="pre" v-html="tour_data.group_leader_description"></p>

        <h5 class="vtd-font-weight-bold" v-if="tour_data.meals">Meals</h5>
        <p class="pre" v-html="tour_data.meals"></p>

        <div
          v-if="
            tour_data.extra_tour_info && tour_data.extra_tour_info.meal_budget
          "
        >
          <h5 class="vtd-font-weight-bold">Meal Budget</h5>
          <p class="pre" v-html="tour_data.extra_tour_info.meal_budget"></p>
        </div>

        <h5
          class="vtd-font-weight-bold"
          v-if="tour_data.about_our_transportation"
        >
          About our Transportation
        </h5>
        <p class="pre" v-html="tour_data.about_our_transportation"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.local_flights">
          Local Flights
        </h5>
        <p class="pre" v-html="tour_data.local_flights"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.solo_travellers">
          Solo Travellers
        </h5>
        <p class="pre" v-html="tour_data.solo_travellers"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.about_accommodation"
        >
          About Accomodation
        </h5>
        <p class="pre" v-html="tour_data.about_accommodation"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.what_to_take">
          What to Take
        </h5>
        <p class="pre" v-html="tour_data.what_to_take"></p>

        <h5 class="vtd-font-weight-bold" v-if="tour_data.packing_list">
          Packing List
        </h5>
        <p class="pre" v-html="tour_data.packing_list"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.laundry">
          Laundry
        </h5>
        <p class="pre" v-html="tour_data.laundry"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.visas_and_entry_requirements"
        >
          Visa and entry requirements
        </h5>
        <p class="pre" v-html="tour_data.visas_and_entry_requirements"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.spending_money">
          Spending Money
        </h5>
        <p class="pre" v-html="tour_data.spending_money"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.money_exchange">
          Money Exchange
        </h5>
        <p class="pre" v-html="tour_data.money_exchange"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.emergency_fund">
          Emergency Fund
        </h5>
        <p class="pre" v-html="tour_data.emergency_fund"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.tipping">
          Tipping
        </h5>
        <p class="pre" v-html="tour_data.tipping"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.departure_tax">
          Departure Tax
        </h5>
        <p class="pre" v-html="tour_data.departure_tax"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.health">
          Health
        </h5>
        <p class="pre" v-html="tour_data.health"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.safety_and_security"
        >
          Safety and Security
        </h5>
        <p class="pre" v-html="tour_data.safety_and_security"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.trip_specific_safety"
        >
          Trip Specific Safety
        </h5>
        <p class="pre" v-html="tour_data.trip_specific_safety"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.a_couple_of_rules"
        >
          A Couple of Rules
        </h5>
        <p class="pre" v-html="tour_data.a_couple_of_rules"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.local_dress">
          Local Dress
        </h5>
        <p class="pre" v-html="tour_data.local_dress"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.special_comments">
          Special Comments
        </h5>
        <p class="pre" v-html="tour_data.special_comments"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.international_flights"
        >
          International Flights
        </h5>
        <p class="pre" v-html="tour_data.international_flights"></p>

        <h5 class="mt-3 vtd-font-weight-bold" v-if="tour_data.joining_hotel">
          Joining Hotel
        </h5>
        <p class="pre" v-html="tour_data.joining_hotel"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.joining_instructions"
        >
          Joining Instructions
        </h5>
        <p class="pre" v-html="tour_data.joining_instructions"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.arrival_complications"
        >
          Arrival Complications
        </h5>
        <p class="pre" v-html="tour_data.arrival_complications"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.emergency_contact"
        >
          Emergency Contact
        </h5>
        <p class="pre" v-html="tour_data.emergency_contact"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.dossier_disclaimer"
        >
          Dossier Disclaimer
        </h5>
        <p class="pre" v-html="tour_data.dossier_disclaimer"></p>

        <h5
          class="mt-3 vtd-font-weight-bold"
          v-if="tour_data.itinerary_disclaimer"
        >
          Itinerary Disclaimer
        </h5>
        <p class="pre" v-html="tour_data.itinerary_disclaimer"></p>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    item: null,
    tour_data: {
      type: Object,
    },
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    returnDays() {
      if (
        this.tour_data &&
        this.tour_data.itinerary &&
        Array.isArray(this.tour_data.itinerary)
      ) {
        return this.tour_data.itinerary.length;
      }
      return "";
    },
  },
  methods: {
    show(htlpagelink) {
      this.$refs["tour-info-modal-ref"].show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.infoBoxIframe {
  height: 590px;
  width: 100%;
}
.vtd-image-text {
  font-size: 3em;
  color: #fff;
  font-weight: 800;
  position: absolute;
  top: 5em;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
.vtd-font-weight-bold {
  font-weight: bolder;
}
.orange {
  color: orange;
  font-weight: bolder;
}
p {
  text-align: left !important;
}

.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}
</style>
